/**
 * Timer Display 显示控制
 * 负责更新时间显示,包括毫秒字体分层
 */

class TimerDisplay {
    constructor() {
        this.containerElement = document.querySelector('.timer-container');
        this.displayElement = document.getElementById('timer-display');
        this.splitRecordsElement = document.getElementById('split-records');
        this.splitListElement = document.getElementById('split-list');
        this.statusElement = document.getElementById('timer-status');
        this.phaseElement = document.getElementById('timer-phase');
        this.roundElement = document.getElementById('timer-round');
    }

    /**
     * 更新时间显示
     * @param {string|object} timeData - 时间数据(字符串或包含毫秒分层的对象)
     * @param {boolean} isNegative - 是否为负数(倒计时超时)
     */
    updateTime(timeData, isNegative = false) {
        if (!this.displayElement) return;

        // 如果是对象,说明需要显示毫秒(字体分层)
        if (typeof timeData === 'object') {
            this.displayElement.innerHTML = `
                <span class="time-main">${timeData.main}</span><span class="ms"><span class="ms-dot">.</span><span class="ms-primary">${timeData.msPrimary}</span><span class="ms-secondary">${timeData.msSecondary}</span></span>
            `;
        } else {
            // 普通字符串显示
            this.displayElement.innerHTML = `<span class="time-main">${timeData}</span>`;
        }

        // 处理负数样式
        if (isNegative) {
            this.displayElement.classList.add('negative');
        } else {
            this.displayElement.classList.remove('negative');
        }
    }

    /**
     * 显示/隐藏 Split 记录区域
     * @param {boolean} show - 是否显示
     */
    toggleSplitRecords(show) {
        if (!this.splitRecordsElement) return;
        this.splitRecordsElement.style.display = show ? 'block' : 'none';
    }

    /**
     * 添加 Split 记录
     * @param {object} splitData - Split 数据 {number, time, milliseconds}
     */
    addSplitRecord(splitData) {
        if (!this.splitListElement) return;

        const splitItem = document.createElement('div');
        splitItem.className = 'split-item';

        // 格式化时间显示
        let timeDisplay = '';
        if (typeof splitData.time === 'object') {
            // 有毫秒
            timeDisplay = `${splitData.time.main}${splitData.time.msPrimary}${splitData.time.msSecondary}`;
        } else {
            timeDisplay = splitData.time;
        }

        splitItem.innerHTML = `
            <span class="split-number">#${splitData.number}</span>
            <span class="split-time">${timeDisplay}</span>
        `;

        this.splitListElement.appendChild(splitItem);

        // 滚动到最新的 Split
        this.splitListElement.scrollTop = this.splitListElement.scrollHeight;
    }

    /**
     * 清空 Split 记录
     */
    clearSplitRecords() {
        if (!this.splitListElement) return;
        this.splitListElement.innerHTML = '';
    }

    /**
     * 更新显示设置(是否显示毫秒)
     * @param {boolean} showMilliseconds - 是否显示毫秒
     */
    updateShowMilliseconds(showMilliseconds) {
        if (!this.displayElement) return;
        this.displayElement.setAttribute('data-show-milliseconds', showMilliseconds);
    }

    /**
     * 获取 Interval 文案
     */
    getIntervalLabels() {
        return {
            work: this.statusElement?.dataset.workLabel || 'WORK',
            rest: this.statusElement?.dataset.restLabel || 'REST'
        };
    }

    /**
     * 更新 Interval 状态显示
     * @param {string} phaseText - 阶段文案
     * @param {string} roundText - 轮次文案
     */
    updateIntervalStatus(phaseText, roundText) {
        if (!this.statusElement) return;
        this.containerElement?.classList.add('has-interval-status');
        this.statusElement.style.display = 'flex';
        if (this.phaseElement) this.phaseElement.textContent = phaseText;
        if (this.roundElement) this.roundElement.textContent = roundText;
    }

    /**
     * 隐藏 Interval 状态显示
     */
    hideIntervalStatus() {
        if (!this.statusElement) return;
        this.statusElement.style.display = 'none';
        this.containerElement?.classList.remove('has-interval-status');
    }
}

// 导出
export default TimerDisplay;
